var _defs, _path, _path2, _text;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMapMarkerPoiI(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#d55e2d;color:white}.cls-1{opacity:0.5;color:white}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    cx: 27.15,
    cy: 27.15,
    r: 27.15,
    d: "M100 50A50 50 0 0 1 50 100A50 50 0 0 1 0 50A50 50 0 0 1 100 50z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    cx: 27.15,
    cy: 27.15,
    r: 16.37,
    d: "M80.147 50A30.147 30.147 0 0 1 50 80.147A30.147 30.147 0 0 1 19.852 50A30.147 30.147 0 0 1 80.147 50z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 35,
    y: 60,
    cy: 127.15,
    fontFamily: "Verdana",
    fontSize: 35,
    fill: "white"
  }, "9")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarkerPoiI);
export default __webpack_public_path__ + "static/media/map_marker_poiI.f993e2dbdaf8d9a7b5d5bf9997933cd3.svg";
export { ForwardRef as ReactComponent };